// SC-4 capability-gated dock placeholder — `is_cogs_author` only.
// Production (§5.6) and Logistics (§5.7) first-bucket sections live in
// dedicated files with honest `hasSignal: () => false` registry rows.

type CapabilityPlaceholderProps = {
  ariaLabel: string;
  title: string;
};

function CapabilityDockPlaceholder({
  ariaLabel,
  title,
}: CapabilityPlaceholderProps) {
  const signalCount = 0;
  if (signalCount <= 0) return null;

  return (
    <section
      aria-label={ariaLabel}
      className="mt-3 rounded-lg border border-gray-200 bg-gray-50 p-3 dark:border-gray-700 dark:bg-zinc-900/40"
    >
      <h3 className="text-[11px] font-semibold uppercase tracking-wide text-gray-700 dark:text-gray-300">
        {title}
      </h3>
    </section>
  );
}

export function ActivityDockCogsPeriodPlaceholderSection() {
  return (
    <CapabilityDockPlaceholder
      ariaLabel="COGS period-close reminder"
      title="COGS period close"
    />
  );
}
